import React, { useState } from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'
import DOMPurify from 'dompurify'

import CheckboxInputCompact from '../../../leevo_ui/CheckboxInputCompact/CheckboxInputCompact'
import Modal from '../../../leevo_ui/Modal/Modal'
function DisclosureAgreementCheckbox({
  disclosureType,
  id,
  agreement,
  disclosureName,
  required = false,
  value,
  onClick
}) {
  const [isModalOpened, setIsModalOpened] = useState(false)

  function generateLabel() {
    let output = []

    if (disclosureType === 'one_liner') {
      output.push(DOMPurify.sanitize(agreement, { ALLOWED_TAGS: [] }))
    } else {
      output.push(
        <Modal
          data-cy="disclosure-modal"
          open={isModalOpened}
          header={disclosureName}
          onClickBackground={() => setIsModalOpened(false)}
          onClickClose={() => setIsModalOpened(false)}
        >
          {parse(DOMPurify.sanitize(agreement.replace(/\n/g, '<br />')))}
        </Modal>
      )
      output.push(
        <span>
          I have read and agree to the{' '}
          <a
            href="#"
            data-cy="disclosure-agreement-checkbox-modal-button"
            className="font-medium text-purple-600 hover:text-purple-500 cursor-pointer"
            onClick={(e) => {
              e.preventDefault()
              setIsModalOpened(true)
            }}
          >
            {disclosureName}
          </a>
        </span>
      )
    }

    if (!required) output.unshift(<span>(optional) </span>)

    return output
  }

  return (
    <div key={id}>
      <CheckboxInputCompact
        id={id}
        data-cy="diclosure-agreement-checkbox"
        value={value}
        checked={value}
        onClick={onClick}
        label={generateLabel()}
      />
    </div>
  )
}

DisclosureAgreementCheckbox.propTypes = {
  disclosureType: PropTypes.oneOf(['one_liner', 'document']).isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  agreement: PropTypes.string.isRequired,
  disclosureName: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.bool,
  onClick: PropTypes.func
}

export default DisclosureAgreementCheckbox
